module.exports = "/assets/2b3c4253edb05aeada8eb0dee0e36a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/GE.png
// module id = 2527
// module chunks = 0